module.exports = __webpack_public_path__ + "img/title-bg.e704aed7.png";